import React from "react";

import { Button, Stack } from "@mui/material";

export interface RealWareButtonProps {
  children?: React.ReactNode;
  disabled?: boolean;
  active: boolean;
  activeLabel: string;
  inactiveLabel: string;
  activeColor?: string;
  activeIcon?: React.ReactNode;
  inactiveIcon?: React.ReactNode;
  showText?: boolean;
  onClick: (active: boolean) => void;
}

export const RealWareButton: React.FC<React.PropsWithChildren<RealWareButtonProps>> = ({
  activeIcon,
  inactiveIcon,
  children,
  active,
  activeLabel,
  inactiveLabel,
  showText,
  disabled = false,
  activeColor = "lightgreen",
  onClick,
}) => {

  const icon = active ? activeIcon : inactiveIcon;
  const label = active ? activeLabel : inactiveLabel;

  let color = active ? activeColor : "lightgray";

  if (disabled) {
    color = "#979797";
  }

  return (
    <Stack
      direction="row"
      sx={{
        borderRadius: 1,
        boxShadow: 1,
        backgroundColor: color,
        alignItems: "center",
        width: "100%",
      }}
    >
      <Button
        disabled={disabled}
        onClick={() => onClick(!active)}
        aria-label={label}
        name={"hf_make_clickable"}
        title={"hf_make_clickable"}
        sx={{
          color: "black",
          fontWeight: 600,
          fontSize: "1.25rem",
          lineHeight: 1.4,
          height: "100%",
          width: "100%",
          justifyContent: "center",
          textAlign: "center",
          gap: 1,
          padding: 1,
        }}
      >
        {icon}
        {showText ? label : null}
      </Button>
      {children}
    </Stack>
  );
};

export default RealWareButton;
